import { render, staticRenderFns } from "./CancellationConfirmation.vue?vue&type=template&id=5dc8a2cc&scoped=true"
import script from "./CancellationConfirmation.vue?vue&type=script&lang=ts"
export * from "./CancellationConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./CancellationConfirmation.vue?vue&type=style&index=0&id=5dc8a2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8a2cc",
  null
  
)

export default component.exports